import React from 'react';
import PropTypes from 'prop-types';
import './LoaderOverlay.scss';

const LoaderOverlay = ({
  isVisible,
  message = 'Loading...',
  size = 'medium',
  overlay = true,
  className = '',
}) => {
  if (!isVisible) return null;

  const overlayClass = overlay ? 'loader-overlay' : '';
  const sizeClass = `loader-${size}`;

  return (
    <div className={`${overlayClass} ${className}`}>
      <div className="loader-content">
        <div className={`spinner ${sizeClass}`}></div>
        {message && <p className="loader-message">{message}</p>}
      </div>
    </div>
  );
};

LoaderOverlay.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  message: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  overlay: PropTypes.bool,
  className: PropTypes.string,
};

export default LoaderOverlay;
